import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const CompanyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const ChoiceList = props => (
    <List filters={<CompanyFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="text"/>
        </Datagrid>
    </List>
);

export default ChoiceList
